import { useFormContext } from '@calendly/form'
import { useOnValueChange } from '@calendly/hooks'
import { useSelector } from 'react-redux'

import { BILLING_FEATURE_KEY } from 'components/event_type_edit'
import { isRestrictedFeatureSelector } from 'features/billing'
import { useEventType } from 'features/event_type_provider'
import { useIsPaypalPpcpFeatureVariation } from 'features/integrations'
import { paypalConnectedSelector } from 'selectors/integrations/paypal_ppcp'

import { LockedCollectPaymentSection } from './collect_payment'
import { CommerceSection } from './commerce_section'
import { EmptyState } from './empty_state'
import {
  isPaypalLegacyConnectedOnEventType,
  isPaypalPpcpConnectedOnEventType,
} from './payment_provider_utils'

export const Payment = ({ isLocked }) => {
  const eventType = useEventType()
  const { payment_method: paymentMethod, is_stripe_connected: isStripeConnected } = eventType

  const { values: { provider }, setFieldValue } = useFormContext()

  const isUpgradeRequired = useSelector((state) => isRestrictedFeatureSelector(state, { featureKey: BILLING_FEATURE_KEY }))
  const isPaypalPpcpConnectedFromStore = useSelector(paypalConnectedSelector)
  const isPaypalPpcpFeatureVariation = useIsPaypalPpcpFeatureVariation()
  const isPaypalConnected = isPaypalLegacyConnectedOnEventType(eventType)
  const isPaypalPpcpConnected = isPaypalPpcpConnectedFromStore || isPaypalPpcpConnectedOnEventType(eventType)
  const isPaypalPpcpConnectionActive = isPaypalPpcpFeatureVariation && isPaypalPpcpConnected
  const isProviderConfigurationRequired = provider === 'none' && !isStripeConnected && !isPaypalConnected && !isPaypalPpcpConnectionActive

  const isPaymentSelectorVisible = !isUpgradeRequired && !isProviderConfigurationRequired
  const hasActivePaymentMethod = isPaymentSelectorVisible && provider !== 'none'

  useOnValueChange(hasActivePaymentMethod, () => {
    if (!hasActivePaymentMethod) {
      setFieldValue('amount', 0, true)
    }
  })

  if (isLocked) return <LockedCollectPaymentSection paymentMethodEnabled={paymentMethod?.enabled} />

  return (
    isPaymentSelectorVisible ? (
      <CommerceSection
        provider={provider}
        paymentMethodEnabled={paymentMethod?.enabled}
        isUpgradeRequired={isUpgradeRequired}
        isStripeConnected={isStripeConnected}
        isPaypalConnected={isPaypalConnected}
        isPaypalPpcpConnected={isPaypalPpcpConnected}
        isPaypalPpcpFeatureVariation={isPaypalPpcpFeatureVariation}
      />
    ) : (
      <EmptyState />
    )
  )
}
